import { InputGroup as BootstrapInputGroup, Form } from 'react-bootstrap';
import styled from 'styled-components';

export const InputGroup = styled(BootstrapInputGroup)`
  max-width: 250px;
  border: 1px solid #e2ebf6 !important;
  ${({ $active }) => $active && `border: 1px solid #2684ff !important;`}
  border-radius: 8px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  input {
    border: none !important;
  }
`;

export const Icon = styled(BootstrapInputGroup.Text)`
  border: none;
  height: 100%;
`;

export const Input = styled(Form.Control)`
  border-left-width: 0;
  padding: 0 0 0 0.5rem !important;
  min-height: 1px !important;
  &:focus {
    border-color: #d2ddec !important;
  }
`;
